module.exports = __webpack_public_path__ + "img/6_111.accdd129.png";